import { AppRemixIcon } from '@/layout/AppComponents';
import { Accordion } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import Sidebar from '../../../../../Sidebar/Sidebar';
import AppLink from '../../../../../../routing/helpers/AppLink';
import FilterSidebarBlock from './FilterSidebarBlock';
import BlockChangeSidebarBlock from './BlockChangeSidebarBlock';
import MilestoneSidebarBlock from './Milestone/MilestoneSidebarBlock';
import LastVerification from './LastVerification';
import LastChange from './LastChange';
import ReportSidebarBlock from './ReportSidebarBlock';
import Translator from '../../../../../components/helpers/Translator';
import PlantManagerSideBarBlock from './Evaluation/PlantManagerSideBarBlock';
import ImportSideBarBlock from './ImportSideBarBlock';
import SupervisionSidebarBlock from './SupervisionSidebarBlock';
import _ from 'lodash';

const EvaluationSidebar = (props) => {
  const url = useLocation().pathname;
  const { moduleBridgeHex, plantHex } = useParams();
  const permissions = useSelector(
    (state) => state.module[moduleBridgeHex]?.permissions,
  );
  const auth = useSelector((state) => state.auth);
  const userBridgePermissions = useSelector(
    (state) => state.module[moduleBridgeHex]?.userBridge?.permissions,
  );
  const global = useSelector((state) => state.global);
  const options = useSelector((state) => state.currentPage?.options);
  const client = useSelector((state) => state.auth.user.client);

  if (!permissions) return <Sidebar toggleable={false} />;

  return (
    <>
      <Sidebar>
        <img
          src={auth.user?.client?.logoUrl}
          className="img-fluid"
          alt={auth.user?.client?.name}
          title={auth.user?.client?.name}
        />
        <Accordion>
          <ul>
            {permissions.gcl?.module?.plant?.lastVerification && <LastVerification />}
            {permissions.gcl?.module?.plant?.lastChange && (
              <>
                <LastChange />
                <li className="divider" />
              </>
            )}
            {permissions?.gcl?.module?.plant?.manageInternalObligations && (
              <li>
                <AppLink
                  path="user_module_legalCompliance_internalObligation"
                  params={{
                    clientID: client.id,
                    moduleBridgeHex,
                    plantHex,
                  }}
                  className="sidebar-element"
                >
                  <AppRemixIcon icon="add" className="sidebar-icon" />{' '}
                  <span className="sb-title">
                    <Translator
                      file="module-legalCompliance"
                      name="internal-obligation"
                    />
                  </span>
                </AppLink>
              </li>
            )}
            {permissions.gcl?.module?.plant?.filters && <FilterSidebarBlock />}
            {_.find(
              permissions.gcl?.module?.plant?.reports,
              (r) => r === true || r === 'milestone',
            ) &&
              (userBridgePermissions?.level !== 2 ||
                userBridgePermissions?.reports?.export === true) && (
                <ReportSidebarBlock />
              )}
            {_.find(
              permissions.gcl?.module?.plant?.reports,
              (r) => r === 'milestone',
            ) &&
              (userBridgePermissions?.level !== 2 ||
                userBridgePermissions?.reports?.export === true) && (
                <MilestoneSidebarBlock />
              )}
            {(userBridgePermissions?.level !== 2 ||
              userBridgePermissions?.reports?.import) && <ImportSideBarBlock />}

            {permissions.gcl?.module?.plant?.evidences?.evidenceList && (
              <li>
                <AppLink
                  path="user_module_legalCompliance_evidences"
                  params={{
                    clientID: client.id,
                    moduleBridgeHex,
                    plantHex,
                  }}
                  className="sidebar-element"
                >
                  <AppRemixIcon icon="file" className="sidebar-icon" />{' '}
                  <span className="sb-title">
                    <Translator
                      file="module-legalCompliance"
                      name="m-gcl-list.evidence"
                    />
                  </span>
                </AppLink>
              </li>
            )}

            <li className="divider" />
            {/* SON 4 GRUPOS DE PERMISOS SEPARADOS POR || (LOS MISMOS GRUPOS QUE ESTÁN DENTRO EN CADA APARTADO */}
            {((permissions.gcl?.module?.plant?.states?.blockChange &&
              (!permissions.gcl?.module?.plant?.states?.blockChange?.allowedUsers ||
                permissions.gcl?.module?.plant?.states?.blockChange?.allowedUsers
                  .length === 0 ||
                permissions.gcl?.module?.plant?.states?.blockChange?.allowedUsers.includes(
                  auth.user.id,
                )) &&
              (userBridgePermissions?.level !== 2 ||
                userBridgePermissions?.writeState === true)) ||
              (permissions.gcl?.module?.plant?.probSevRisk?.probSevBlockChange &&
                (userBridgePermissions?.level !== 2 ||
                  userBridgePermissions?.writeProvSev === true) &&
                ((permissions.gcl?.module?.plant?.probSevRisk?.probability &&
                  permissions.gcl?.module?.plant?.probSevRisk?.probability !==
                    'wn') ||
                  (permissions.gcl?.module?.plant?.probSevRisk?.severity &&
                    permissions.gcl?.module?.plant?.probSevRisk?.severity !==
                      'wn'))) ||
              (permissions.gcl?.module?.plant?.calendar &&
                permissions.gcl?.module?.plant?.calendar?.blockChange &&
                (userBridgePermissions?.level !== 2 ||
                  userBridgePermissions?.writeCalendar === true)) ||
              (permissions.gcl?.module?.plant?.evidences &&
                (permissions.gcl?.module?.plant?.evidences?.blockChange ||
                  permissions.gcl?.module?.plant?.evidences?.cloneBlockChange) &&
                (userBridgePermissions?.level !== 2 ||
                  userBridgePermissions?.evidences?.read === true))) && (
              <BlockChangeSidebarBlock />
            )}
            {permissions.gcl?.module?.plant?.customPlantManagers && (
              <PlantManagerSideBarBlock />
            )}
            {permissions.gcl?.module?.plant?.plantInfo &&
              !_.isEmpty(permissions.gcl?.module?.plant?.plantInfo) && (
                <li>
                  <AppLink
                    path="user_module_legalCompliance_plantInformation"
                    params={{
                      moduleBridgeHex,
                      plantHex,
                    }}
                    className="sidebar-element"
                  >
                    <AppRemixIcon icon="information" className="sidebar-icon" />{' '}
                    <span className="sb-title">
                      <Translator
                        file="module-lawFinder"
                        name="module.lf.information"
                      />
                    </span>
                  </AppLink>
                </li>
              )}
            {options?.subModuleBridgeComsaReportsHex &&
              (!permissions?.gcl?.module?.plant?.indicators ||
                !permissions?.gcl?.module?.plant?.indicators?.visibility ||
                (_.isArray(
                  permissions?.gcl?.module?.plant?.indicators?.visibility?.users,
                ) &&
                  permissions?.gcl?.module?.plant?.indicators?.visibility?.users?.includes(
                    auth.user.id,
                  ))) && (
                <li>
                  <AppLink
                    path="user_module_comsaReports_home"
                    params={{
                      moduleBridgeHex,
                      subModuleBridgeHex: options.subModuleBridgeComsaReportsHex,
                      plantHex,
                    }}
                    className="sidebar-element"
                  >
                    <AppRemixIcon icon="file-text" className="sidebar-icon" />{' '}
                    <span className="sb-title">
                      <Translator file="module-comsaReports" name="indicators" />
                    </span>
                  </AppLink>
                </li>
              )}
            {options?.subModuleBridgeComsaEnvironmentalHex && (
              <li>
                <AppLink
                  path="user_module_comsaEnvironmental_home"
                  params={{
                    moduleBridgeHex,
                    subModuleBridgeHex: options.subModuleBridgeComsaEnvironmentalHex,
                    plantHex,
                  }}
                  className="sidebar-element"
                >
                  <AppRemixIcon icon="leaf" className="sidebar-icon" />{' '}
                  <span className="sb-title">
                    <Translator
                      file="module-comsaEnvironmental"
                      name="environmental.aspects"
                    />
                  </span>
                </AppLink>
              </li>
            )}
            {options?.subModuleBridgeQseReportsHex && (
              <li>
                <AppLink
                  path="user_module_qseReports_home"
                  params={{
                    moduleBridgeHex,
                    subModuleBridgeHex: options.subModuleBridgeQseReportsHex,
                    plantHex,
                  }}
                  className="sidebar-element"
                >
                  <AppRemixIcon icon="file-text" className="sidebar-icon" />{' '}
                  <span className="sb-title">QHSE monthly report</span>
                </AppLink>
              </li>
            )}
            {permissions.gcl?.module?.plant?.userObligationForm &&
              options?.hasObligationForm && (
                <li
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="obligations.form"
                    />,
                  )}
                >
                  <AppLink
                    path="user_module_legalCompliance_plantObligationForm_manage"
                    params={{
                      clientID: client.id,
                      moduleBridgeHex,
                      plantHex,
                    }}
                    className="sidebar-element"
                  >
                    <AppRemixIcon icon="file-edit" className="sidebar-icon" />{' '}
                    <span className="sb-title">
                      <Translator
                        file="module-legalCompliance"
                        name="obligations.form.short"
                      />
                    </span>
                  </AppLink>
                </li>
              )}
            {options?.environmentalAspectsAssessment && (
              <li
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-legalCompliance"
                    name="environmental.aspects.assessment"
                  />,
                )}
              >
                <AppLink
                  path="user_module_environmentalAspectsAssessment_assessment_current"
                  params={{
                    clientID: client.id,
                    moduleBridgeHex: options?.environmentalAspectsAssessment,
                    plantHex,
                  }}
                  className="sidebar-element"
                >
                  <AppRemixIcon icon="file-edit" className="sidebar-icon" />{' '}
                  <span className="sb-title">
                    <Translator
                      file="module-legalCompliance"
                      name="environmental.aspects.assessment"
                    />
                  </span>
                </AppLink>
              </li>
            )}
            {permissions.gcl?.module?.submodules?.correctiveActions
              ?.supervisionSystem &&
              userBridgePermissions?.level === 0 && <SupervisionSidebarBlock />}
            {/* <HelpSideBarBlock /> */}
          </ul>
        </Accordion>
      </Sidebar>
    </>
  );
};
export default EvaluationSidebar;
